import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M9 11.11a1.244 1.244 0 0 1-1.25-1.24V2c0-.41.34-.75.75-.75h7c.41 0 .75.34.75.75v7.86c0 .5-.29.95-.75 1.14-.45.2-.98.11-1.35-.23L12 8.8l-2.15 1.98c-.24.22-.54.33-.85.33m3-3.9c.3 0 .61.11.85.33l1.9 1.75V2.75h-5.5v6.54l1.9-1.75c.24-.22.55-.33.85-.33M17.5 14.75h-4.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4.25c.41 0 .75.34.75.75s-.34.75-.75.75M17.5 18.75H9c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h8.5c.41 0 .75.34.75.75s-.34.75-.75.75" }, null, -1)
  ]))]))
}
export default { render: render }